import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Skeleton } from '@/components/ui/skeleton';
import { Camera } from 'lucide-react';
import { HOW_IT_WORKS } from '@/constants/testIds';
import { PLATFORM_TOUR_SLIDES } from '@/lib/howItWorksContent';

// Real product screenshots go here once supplied (drop files into
// /app/frontend/public/how-it-works/ and set `image` in howItWorksContent.js
// — same pattern as lib/siteImages.js). Until then each slide renders a
// Skeleton placeholder with its caption, per design guidelines (no stock
// photography allowed for this section).
export const PlatformTourCarousel = () => {
  return (
    <Carousel data-testid={HOW_IT_WORKS.tourCarousel} className="w-full" opts={{ loop: true }}>
      <CarouselContent>
        {PLATFORM_TOUR_SLIDES.map((slide) => (
          <CarouselItem key={slide.slug} data-testid={HOW_IT_WORKS.tourSlide(slide.slug)}>
            <div className="rounded-2xl border border-[hsl(var(--lxra-border))] bg-black/40 overflow-hidden">
              <AspectRatio ratio={16 / 10}>
                {slide.image ? (
                  <img
                    src={slide.image}
                    alt={`${slide.title} interface screenshot`}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="relative h-full w-full">
                    <Skeleton className="absolute inset-0 rounded-none" />
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-[hsl(var(--lxra-muted))]">
                      <Camera className="h-6 w-6" />
                      <span className="text-[10px] uppercase tracking-[0.18em]">Screenshot coming soon</span>
                    </div>
                  </div>
                )}
              </AspectRatio>
              <div className="p-5">
                <p data-testid={HOW_IT_WORKS.tourSlideTitle} className="text-sm font-semibold text-[hsl(var(--lxra-fg))] lxra-mono">
                  {slide.title}
                </p>
                <p className="mt-1 text-sm text-[hsl(var(--lxra-muted))] leading-relaxed">{slide.caption}</p>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious data-testid={HOW_IT_WORKS.tourPrev} />
      <CarouselNext data-testid={HOW_IT_WORKS.tourNext} />
    </Carousel>
  );
};
